import React, { Component } from "react";
import Content from "../../content/Content";

export class OnlineAccessInformation extends Component {
  render() {
    return (
      <div className="container online-page-content-block online-information-page">
        <div className="row">
          {/* <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3"> */}
            <h1 className="axa-headline">
              <Content name={this.props.headerText} />
            </h1>
            <div className="axa-body-text-3">{this.props.children}</div>
          </div>
        {/* </div> */}
      </div>
    );
  }
}
export default OnlineAccessInformation;
